import { Helmet } from 'react-helmet'
import DoubleClickHeart from './DoubleClickHeart'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Double Click Heart</title>
    </Helmet>
    <DoubleClickHeart />
  </>
)
export default Wrapper
